module.exports = __webpack_public_path__ + "static/media/store.dbd7188d.jpg";